(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@big-d-companies/image"] = factory();
	else
		root["@big-d-companies/image"] = factory();
})(this, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ src)
});

;// CONCATENATED MODULE: external "react"
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_namespaceObject);
;// CONCATENATED MODULE: external "prop-types"
const external_prop_types_namespaceObject = require("prop-types");
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_namespaceObject);
;// CONCATENATED MODULE: external "next/legacy/image"
const image_namespaceObject = require("next/legacy/image");
var image_default = /*#__PURE__*/__webpack_require__.n(image_namespaceObject);
;// CONCATENATED MODULE: ./src/next-image.jsx
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }


const StorybookNextImage = props => /*#__PURE__*/external_react_default().createElement((image_default()), _extends({}, props, {
  unoptimized: true,
  loader: ({
    src
  }) => {
    return src;
  }
}));
const isStorybook = process.env.STORYBOOK === "true";
/* harmony default export */ const next_image = (isStorybook ? StorybookNextImage : (image_default()));
;// CONCATENATED MODULE: ./src/image.jsx




// Lazy load threshold
// TODO: Extract into a config file
const IMG_LAZY_LOAD_THRESHOLD = "200%";

// using layout-fill in image & aspect-ratio plugin in the wrapper to set height & width
const Image = ({
  src,
  alt,
  image,
  // alternatively pass entire image object
  className,
  // wrapper class name - pass width here
  layout = "responsive",
  objectFit = "",
  imageClassName,
  dataPreload = false,
  // defaults
  priority = false,
  // defaults
  sizes = "100vw",
  reference,
  width,
  height
}) => {
  // check image data in image object prop as well
  const _src = src ? src : image?.sourceUrl;
  const _alt = alt ? alt : image?.altText;
  return /*#__PURE__*/external_react_default().createElement((external_react_default()).Fragment, null, _src ? /*#__PURE__*/external_react_default().createElement("figure", {
    className: className,
    ref: reference
  }, /*#__PURE__*/external_react_default().createElement(next_image, {
    src: _src,
    alt: _alt,
    layout: layout,
    objectFit: objectFit,
    sizes: sizes,
    priority: priority,
    "data-preload": dataPreload,
    className: imageClassName,
    lazyBoundary: IMG_LAZY_LOAD_THRESHOLD,
    width: width,
    height: height
  })) : null);
};
Image.propTypes = {
  src: (external_prop_types_default()).string.isRequired,
  alt: (external_prop_types_default()).string,
  image: (external_prop_types_default()).object,
  className: (external_prop_types_default()).string,
  // TODO: Are there additional layouts not represented here?
  layout: external_prop_types_default().oneOf(["responsive", "raw"]),
  objectFit: (external_prop_types_default()).string,
  imageClassName: (external_prop_types_default()).string,
  dataPreload: (external_prop_types_default()).bool,
  priority: (external_prop_types_default()).bool,
  sizes: (external_prop_types_default()).string,
  reference: (external_prop_types_default()).object,
  width: (external_prop_types_default()).string.isRequired,
  height: (external_prop_types_default()).string.isRequired
};
/* harmony default export */ const src_image = (Image);
;// CONCATENATED MODULE: ./src/index.js

/* harmony default export */ const src = (src_image);
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map